import React, { useRef } from 'react'
import Link from 'next/link'
import styles from './Tags.module.scss'

type Props = {
  tag1text: string
  tag2text?: string
  tag3text?: string
  tag1src: string
  tag2src?: string
  tag3src?: string
  industryTagText?: string
  industryTagSrc?: string
}

const Tags: React.FC<Props> = ({
  tag1text,
  tag1src,
  tag2text,
  tag2src,
  tag3text,
  tag3src,
  industryTagText,
  industryTagSrc,
}) => {
  const tag = useRef<HTMLUListElement>()

  return (
    <ul className={styles.ul} ref={tag}>
      <Link href={tag1src}>
        <li className={`${styles.skin_colorBox} ${styles.tag}`}>
          <a className={styles.tag_linkbox} href={tag1src}>
            {tag1text}
          </a>
        </li>
      </Link>
      {tag2text && (
        <Link href={tag2src}>
          <li className={`${styles.skin_colorBox} ${styles.tag}`}>
            <a className={styles.tag_linkbox} href={tag2src}>
              {tag2text}
            </a>
          </li>
        </Link>
      )}
      {tag3text && (
        <Link href={tag3src}>
          <li className={`${styles.skin_colorBox} ${styles.tag}`}>
            <a className={styles.tag_linkbox} href={tag3src}>
              {tag3text}
            </a>
          </li>
        </Link>
      )}
      {industryTagText && (
        <Link href={industryTagSrc}>
          <li className={`${styles.skin_colorBox} ${styles.tag}`}>
            <a className={styles.industry_linkbox} href={industryTagSrc}>
              {industryTagText}
            </a>
          </li>
        </Link>
      )}
    </ul>
  )
}

export default Tags
